import { cn } from "@/ds/utils";
import type { FC } from "react";

export interface LimitProps {
	border?: boolean;
	children: React.ReactNode;
}

export const Limit: FC<LimitProps> = ({ border, children }: LimitProps) => {
	return (
		<div className={cn("@md:max-w-128 w-full p-3 @md:mt-12 mx-auto", border ? "@md:border @md:rounded-lg" : "@md:p-0")}>
			{children}
		</div>
	);
};
